export default function ScoreSlider({ label, value, onChange, testId, lowLabel = "Low", highLabel = "High" }) {
  return (
    <div className="bg-white rounded-2xl p-5 card-shadow">
      <div className="flex items-center justify-between mb-3">
        <span className="font-semibold text-ink text-base">{label}</span>
        <span
          className="font-serif text-2xl font-bold text-brand w-10 text-right"
          data-testid={testId ? `${testId}-value` : undefined}
        >
          {value}
        </span>
      </div>
      <input
        type="range"
        min={1}
        max={10}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="reset-slider"
        data-testid={testId}
      />
      <div className="flex justify-between mt-2 text-xs text-ink-muted">
        <span>{lowLabel}</span>
        <span>{highLabel}</span>
      </div>
    </div>
  );
}
